import { Injectable } from '@angular/core';
import { driver, type Config, type DriveStep } from 'driver.js';

@Injectable({ providedIn: 'root' })
export class HostedSnapshotsTourService {
  start(): void {
    const steps: DriveStep[] = [
      {
        element: '#tour-snap-header',
        popover: {
          title: 'Hosted Snapshots',
          description:
            'Snapshots are point-in-time captures of hosted-user data for a domain. Use this screen to browse saved snapshots or compare two snapshots to see what changed.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-snap-toolbar',
        popover: {
          title: 'Domain & Controls',
          description:
            'Select a <strong>domain</strong> to load its snapshots. Adjust the <strong>limit</strong> to control how many are fetched (default 100 ≈ last 3 months). Click the refresh icon to reload.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-snap-tabs',
        popover: {
          title: 'Tabs: Saved vs Compare',
          description:
            '<strong>Saved Snapshots</strong> — browse and click a row to preview its content on the right panel. <strong>Compare Snapshots</strong> — pick two snapshots and diff them to see additions, changes, and removals by site/scope/service type.',
          side: 'bottom',
          align: 'start',
        },
      },
    ];

    const config: Config = {
      showProgress: true,
      nextBtnText: 'Next',
      prevBtnText: 'Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
    };

    driver(config).drive();
  }
}
